
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `“... tarayıcısında aç” seçeneğine dokunun`,
's182ab2d6c997515f': `Daha iyi bir deneyim ve kolay erişim için Ana Ekranınıza ekleyin.`,
's224cbcec014ef6b5': `Gezinme çubuğunda Paylaş'a basın`,
's233af3b7eb5e0364': `Telefona kısayol ekle`,
's37a9e8aec5713460': `Daha Fazla`,
's4c3161035f3a1413': `Menüye basın`,
's4e1e10a6ca408245': `"Ana Ekrana Ekle"ye dokunun`,
's6196153c4b0c1ea0': `Yükle`,
's633502f7cff4f847': `Tarayıcı menünüzü açın`,
's681e399d63311fba': `Galeriyi Göster`,
's6d14a4f70ba4e3cf': `Paylaş simgesi yoksa Menüye basın`,
's922329d6f6213590': `Dock’a Ekle`,
's9c63a79ffcc2a3a3': `"Ana Ekrana Ekle" seçeneğine basın`,
'sa2d71bfd9525168d': `"Dock’a Ekle" seçeneğine basın`,
'sa5ef80b4bb9b39f8': `Küçült`,
'sb527eca1c1d7e7be': `Uygulama içi tarayıcı menüsünü açın`,
'sba52286c21552a4e': `Daha iyi bir deneyim ve kolay erişim için cihazınıza yükleyin.`,
'sc16e00a7a8b2fde2': `Geri`,
'scdaf4bbff76674c8': `Ana Ekrana Ekle`,
'sd18a5b85f599ff3c': `Kopyalanan bağlantıyı Safari'de açın`,
'se72fc3a84f9b51c3': `Bağlantıyı kopyalamak için dokunun`,
'se740f75b95a51807': `Daha iyi bir deneyim ve kolay erişim için Dock’a ekleyin.`,
'sfa6c42cdf48d93d2': `Ancak bu tarayıcı bu özelliği desteklemiyor. Devam etmek için bağlantıyı harici bir tarayıcıda açın.`,
'sfb78526365796a41': `Paylaş menüsünde "Daha Fazla Gör" seçeneğine basın`,
'sfea652f6580ff086': `Bu site uygulama işlevselliğine sahiptir.`,
    };
  